/**
 * =============================================================================
 * Project: lajt-online.pl
 * Created Date: 2018-02-22, 13:56:28
 * Author: Sebastian Drzewicki <sebastian.drzewicki@gmail.com>
 * =============================================================================
 * Last Modified: 2018-02-22, 14:12:17
 * Modified By: Sebastian Drzewicki
 * =============================================================================
 * Copyright (c) 2018 Telestrada
 * =============================================================================
 */
import {
  FILL_BRAND_THEME,
} from './mutation-types';

export default {
  [FILL_BRAND_THEME](state, payload) {
    const _state = state;
    _state.brandTheme = payload.theme;
    _state.brandLogos = payload.logos;
    _state.isError = payload.is_error;
    _state.brandId = payload.brand_id;
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/Brand/mutations.js